import {Link} from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

function StoresMenu(){

const MenuCard = ({link,title,icon,color}) => (

<div className="col-xl-3 col-lg-4 col-md-6 mb-4">

<Link to={link} className="menu-link">

<div className="menu-card" style={{borderTop:`4px solid ${color}`}}>

<div className="menu-icon" style={{color:color}}>
<FontAwesomeIcon icon={icon} size="2x"/>
</div>

<p className="menu-title">{title}</p>

</div>

</Link>

</div>

)

return(

<section className="container-fluid mt-4">

<h5 className="menu-section-title">Stores Master</h5>

<div className="row">

<MenuCard link="/add-supplier" title="Add Supplier" icon="fa-solid fa-truck-field" color="#0d6efd"/>

<MenuCard link="/add-eqp-cat" title="Add Equipment Category" icon="fa-solid fa-layer-group" color="#20c997"/>

<MenuCard link="/add-eqp-subcat" title="Add Equipment Subcategory" icon="fa-solid fa-sitemap" color="#6f42c1"/>

<MenuCard link="/equip-list" title="Equipment List" icon="fa-solid fa-toolbox" color="#fd7e14"/>

<MenuCard link="/eqp-raise-indent" title="Raise Indent" icon="fa-solid fa-file-circle-plus" color="#dc3545"/>

<MenuCard link="/indent-eqp-list" title="View Indent" icon="fa-solid fa-list" color="#198754"/>

</div>


<h5 className="menu-section-title">Stores Entry</h5>

<div className="row">

<MenuCard link="/add-eqp-product" title="New Equipment Entry" icon="fa-solid fa-plus-circle" color="#0d6efd"/>

<MenuCard link="/eqp-grn-entry" title="GRN Entry" icon="fa-solid fa-file-import" color="#20c997"/>

<MenuCard link="/eqp-grn-list" title="View GRN" icon="fa-solid fa-file-lines" color="#6f42c1"/>

<MenuCard link="/eqp-po-list" title="View PO" icon="fa-solid fa-file-invoice" color="#fd7e14"/>

<MenuCard link="/eqp-purchase-return" title="Purchase Return" icon="fa-solid fa-arrow-rotate-left" color="#dc3545"/>

<MenuCard link="/supplier-search" title="Supplier-wise Payment" icon="fa-solid fa-money-bill-transfer" color="#198754"/>

</div>


<h5 className="menu-section-title">Stores Reports</h5>

<div className="row">

<MenuCard link="/eqp-return-report" title="Purchase Return Report" icon="fa-solid fa-rotate-left" color="#0d6efd"/>

<MenuCard link="/eqp-gst-report" title="Purchase GST Report" icon="fa-solid fa-file-invoice-dollar" color="#20c997"/>

<MenuCard link="/eqp-gst-stat" title="Purchase GST Statement" icon="fa-solid fa-chart-pie" color="#6f42c1"/>

</div>

</section>

)

}

export default StoresMenu;